import React, { forwardRef } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import some from 'lodash/some';
import { typographyClasses as classes } from './typographyClasses';
import { allowedBoldVariants, TypographyRoot } from './Typography.style';

const Typography = forwardRef(
  (
    {
      children,
      weight = 'normal',
      variant,
      className: incomingClassName,
      ...rest
    },
    ref
  ) => {
    const isBoldAllowed = some(allowedBoldVariants, item => item === variant);
    if (weight === 'bold' && variant) {
      if (!isBoldAllowed) {
        console.warn(
          `${variant} variant does not support bold weight (Typography - fe-ui-core).`
        );
      }
    }

    return (
      <TypographyRoot
        weight={weight}
        variant={variant}
        className={clsx(
          {
            [classes.hero1]: variant === 'hero1'
          },
          incomingClassName
        )}
        ref={ref}
        data-qa-id="typography"
        isBoldAllowed={isBoldAllowed}
        {...rest}>
        {children}
      </TypographyRoot>
    );
  }
);

Typography.propTypes = {
  children: PropTypes.node,
  variant: PropTypes.oneOf([
    'h1',
    'h2',
    'h3',
    'body1',
    'body2',
    'caption',
    'button',
    'overline',
    'inherit',
    'hero1'
  ]),
  weight: PropTypes.oneOf(['normal', 'bold'])
};

Typography.displayName = 'Typography';
Typography.classes = classes;
Typography.shouldClassesExampleBeOnRoot = true;

export default Typography;
